import { ReactRenderer } from '@tiptap/react'
import tippy from 'tippy.js'
import MentionList from './MentionList';
import { callBackendApi } from '@/utils/common';


let vendorsData = [];

const suggestion =  {
  items: async({ query })=>{
    // filter vendors data based on user input query
    return vendorsData.filter( item => item.companyName.toLowerCase().startsWith(query.toLowerCase()))
  },

  render: () => {
    let component
    let popup
    // get all vendors data for later find vendor using query
    callBackendApi({
      method : "get",
      url : "/vendors",
      params : {
        select : "companyName slug companyLogo url"
      }
    }).then(({data : {data}}) => {
      vendorsData = data;
    })
    .catch(()=>console.log("Unable to load vendors data for mention list."));
    
    return {
      onStart: props => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        })
        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        })
      },
      onUpdate : (props)=>{
        component.updateProps(props);
        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        })
      },
      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide()
          return true
        }
        return component.ref?.onKeyDown(props)
      },
      onExit() {
        popup[0].destroy()
        component.destroy()
      },
    }
  },
}


export default suggestion;